import { FC } from 'react';

import { CustomerContactInfoModel } from '../../../models/customer.model';
import { MessageCard } from '../../message-card/message-card';
import { Flex, Grid, Text } from '@servicetitan/anvil2';

interface ContactInfoProps {
    data: CustomerContactInfoModel;
    className?: string;
}

export const ContactInfo: FC<ContactInfoProps> = ({ data, className }) => {
    return (
        <MessageCard flexDirection="column" className={className}>
            <Text variant="headline" el="h3" size="small">
                Contact Information
            </Text>

            {data.name && (
                <div className="m-b-1">
                    <Text variant="eyebrow" className="m-b-half" size="small">
                        Customer Name
                    </Text>
                    <Text size="small">{data.name}</Text>
                </div>
            )}

            <div className="m-b-1">
                <Text variant="eyebrow" className="m-b-half" size="small">
                    Address
                </Text>
                <Text size="small">{data.address}</Text>
            </div>

            <Grid
                templateColumns="1fr 1fr"
                gap="2"
                justifyContent="space-between"
                alignItems="stretch"
            >
                <Flex direction="column">
                    <Text variant="eyebrow" className="m-b-half" size="small">
                        Phone Number
                    </Text>
                    <Text size="small">{data.phone_number}</Text>
                </Flex>
                <Flex direction="column">
                    <Text variant="eyebrow" className="m-b-half" size="small">
                        Email
                    </Text>
                    <Text size="small">{data.email}</Text>
                </Flex>
            </Grid>
        </MessageCard>
    );
};
